export { default as Characteristics } from './Characteristics';
